//
//
//
//
//
//
//
//
//
//

export default {
  data() {
    return {
      // key: value
    }
  },
  props: {
    element: {
      type: Object,
      default: ()=>{
        return {}
      }
    },
    schemes:{
      type: Array,
      default: ()=>{
        return []
      }
    }
  },
  methods: {
    schemeLayerShow(element) {
      console.log(element)
      this.$emit("schemeLayerShow",element)

    },
  },
}
